import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { Page } from "../../models";
import { navigate, eventEmitter, notification } from "../../services";
import { PAGE_EDITOR } from "../../settings";
import { FORM_CLEAR, FORM_END_PROCESSING } from "../../lib";
import { AxiosResponse } from "axios";
import {
    PAGE_FETCH_ALL,
    PAGE_FETCH,
    PAGE_SET,
    PAGE_DESTROY,
    PAGE_SAVE,
    PAGE_REMOVE,
    PAGE_CREATE,
    PAGE_SET_MULTIPLE,
    PAGE_SET_POSITION,
} from "./actions";

function* fetchPages(action: {
    type: typeof PAGE_FETCH_ALL;
    payload: {
        doc_id: number;
        redirect: string;
    };
}) {
    const { doc_id, redirect } = action.payload;
    try {
        const { data: rows }: AxiosResponse<Array<any>> = yield call(
            [Page, "list"],
            { doc_id }
        );
        yield put({
            type: PAGE_SET_MULTIPLE,
            payload: rows,
        });

        if (redirect === PAGE_EDITOR) {
            navigate.to(`/app/e/${doc_id}/${rows[0]["id"]}`);
        }
    } catch (e) {}
}

function* onFetchPages() {
    yield takeLatest(PAGE_FETCH_ALL, fetchPages);
}

function* fetchPage(action: {
    type: typeof PAGE_FETCH;
    payload: {
        doc_id: number;
        page_id: number;
    };
}) {
    try {
        const { doc_id, page_id } = action.payload;
        const {
            data,
        }: AxiosResponse<{
            id: number;
            [x: string]: any;
        }> = yield call([Page, "fetch"], page_id, { doc_id });
        yield put({
            type: PAGE_SET,
            payload: {
                data,
                id: data.id,
            },
        });
    } catch (e) {}
}

function* onFetchPage() {
    yield takeEvery(PAGE_FETCH, fetchPage);
}

function* createPage(action: {
    type: typeof PAGE_CREATE;
    payload: {
        doc_id: number;
        data: any;
        redirect: string;
    };
}) {
    try {
        const { doc_id, data, redirect } = action.payload;
        const res: AxiosResponse<{
            id: number;
            [x: string]: any;
        }> = yield call([Page, "create"], data, { doc_id });
        yield put({
            type: PAGE_SET,
            payload: {
                id: res.data.id,
                data: res.data,
            },
        });

        if (redirect === PAGE_EDITOR) {
            navigate.to(`/app/e/${doc_id}/${res.data.id}`);
        }

        if (!redirect) {
            eventEmitter.emit(FORM_END_PROCESSING);
            eventEmitter.emit(FORM_CLEAR);
            notification.set("pageForm.created", "s");
        }
    } catch (e) {}
}

function* onCreatePage() {
    yield takeLatest(PAGE_CREATE, createPage);
}

function* savePage(action: {
    type: typeof PAGE_SAVE;
    payload: {
        doc_id: number;
        page_id: number;
        data: any;
    };
}) {
    try {
        const { doc_id, page_id, data } = action.payload;
        const res: AxiosResponse<{
            id: number;
            [x: string]: any;
        }> = yield call([Page, "save"], data, page_id, { doc_id });
        yield put({
            type: PAGE_SET,
            payload: {
                id: res.data.id,
                data: res.data,
            },
        });
        eventEmitter.emit(FORM_END_PROCESSING);
        // notification.set('pageForm.saved', 's')
    } catch (e) {
        eventEmitter.emit(FORM_END_PROCESSING);
        // notification.set('pageForm.failed', 'f')
    }
}

function* onSavePage() {
    yield takeLatest(PAGE_SAVE, savePage);
}

function* destroyPage(action: {
    type: typeof PAGE_DESTROY;
    payload: {
        page_id: number;
        doc_id: number;
    };
}) {
    try {
        const { doc_id, page_id } = action.payload;
        yield call([Page, "destroy"], page_id, { doc_id });
        yield put({
            type: PAGE_REMOVE,
            payload: { page_id },
        });
        eventEmitter.emit("page.deleted");
    } catch (e) {}
}

function* onDestroyPage() {
    yield takeEvery(PAGE_DESTROY, destroyPage);
}

function* setPositions(action: {
    type: typeof PAGE_SET_POSITION;
    payload: {
        doc_id: number;
        positions: Array<number>;
    };
}) {
    try {
        const { doc_id, positions } = action.payload;
        yield call([Page, "save"], positions, "positions", { doc_id });
        eventEmitter.emit("page.positionsSaved");
    } catch (e) {}
}

function* onSetPagePositions() {
    yield takeEvery(PAGE_SET_POSITION, setPositions);
}

export {
    onFetchPage,
    onFetchPages,
    onCreatePage,
    onSavePage,
    onDestroyPage,
    onSetPagePositions,
};
